import { CompetitionTypeSelect } from '~/pages/competition/components/competition-type-select';
import { DisciplineSelect } from '~/pages/discipline/components/discipline-select';
import { WeightClassSelect } from '~/pages/weight/components/weight-class-select';
import { CategorySelect } from '~/pages/categories/components/category-select';
import { SexFilterSelect } from '~/pages/sex/components/sex-filter-select';
import { useFilterForm } from '~/hooks/useFilterForm';
import { querySchema } from '../query-schema';
import { Grid } from '~/components/Grid/Grid';
import { toIsMaleFilter } from '~/utils/sex';
import { Input } from '~/components/Input';
import { ChangeEvent } from 'react';

export function RankingListFilter() {
  const { setValue, values } = useFilterForm(querySchema.parse);

  function handleCompetitionTypeChange(event: ChangeEvent<HTMLSelectElement>) {
    setValue('competition_type_id', event.target.value);
    setValue('age_category_id', undefined);
    setValue('weight_class_id', undefined);
  }

  function handleAgeCategoryChange(event: ChangeEvent<HTMLSelectElement>) {
    setValue('age_category_id', event.target.value);
    setValue('weight_class_id', undefined);
  }

  function handleSexChange(event: ChangeEvent<HTMLSelectElement>) {
    setValue('sex', event.target.value);

    if (values.weight_class_id !== undefined) {
      setValue('weight_class_id', undefined);
    }
  }

  return (
    <div
      style={{
        borderBottom: '2px solid var(--color-fg-secondary)',
        paddingBottom: 'var(--size-4)',
        marginBottom: 'var(--size-4)',
      }}
    >
      <Grid>
        <Grid.Item cols={{ sm: 6, md: 4 }}>
          <CompetitionTypeSelect
            defaultValue={values.competition_type_id}
            onChange={handleCompetitionTypeChange}
            placeholder={undefined}
          />
        </Grid.Item>

        <Grid.Item cols={{ sm: 6, md: 4 }}>
          <CategorySelect
            query={{ competition_types: values.competition_type_id ? [values.competition_type_id] : undefined }}
            defaultValue={values.age_category_id}
            onChange={handleAgeCategoryChange}
          />
        </Grid.Item>

        <Grid.Item cols={{ sm: 6, md: 2 }}>
          <SexFilterSelect onChange={event => handleSexChange(event)} defaultValue={values.sex} />
        </Grid.Item>

        <Grid.Item cols={{ sm: 6, md: 2 }}>
          <WeightClassSelect
            query={{
              competition_types: values.competition_type_id ? [values.competition_type_id] : undefined,
              age_category: values.age_category_id ?? undefined,
              is_male: toIsMaleFilter(values.sex),
            }}
            onChange={event => setValue('weight_class_id', event.target.value)}
            key={`${values.sex}-${values.weight_class_id}`}
            defaultValue={values.weight_class_id}
            name="weight_class_id"
          />
        </Grid.Item>

        <Grid.Item cols={{ sm: 6, md: 4 }}>
          <DisciplineSelect
            query={{ competition_type: values.competition_type_id ? values.competition_type_id : undefined }}
            onChange={event => setValue('discipline', event.target.value)}
            defaultValue={values.discipline}
            name="discipline"
          />
        </Grid.Item>

        <Grid.Item cols={{ sm: 6, md: 4 }}>
          <Input.Field
            onChange={event => setValue('from_date', event.target.value)}
            defaultValue={values.from_date}
            aria-label="Från datum"
            type="date"
          />
        </Grid.Item>

        <Grid.Item cols={{ sm: 6, md: 4 }}>
          <Input.Field
            onChange={event => setValue('to_date', event.target.value)}
            defaultValue={values.to_date}
            aria-label="Till datum"
            type="date"
          />
        </Grid.Item>
      </Grid>
    </div>
  );
}
